import PropTypes from 'prop-types';

import { srcOrNextImageProp } from './imageProps';

export default {
  capitalizeLabel: PropTypes.bool,
  compactMode: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  dataClick: PropTypes.string,
  dataFrom: PropTypes.string,
  dataTestId: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  imageUrl: srcOrNextImageProp,
  icon: srcOrNextImageProp,
  selectedIcon: srcOrNextImageProp,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]).isRequired,
  onClick: PropTypes.func.isRequired,
  renderDescription: PropTypes.func,
  selectable: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  theme: PropTypes.oneOf(['account', 'consultation', 'feedback', 'faq']),
  twoColumns: PropTypes.bool,
  align: PropTypes.oneOf(['center', 'flex-start']),
  className: PropTypes.string,
};
